<template>
  <div class="school-subject-permissions">
    <el-form :inline="true" class="form-style" size="mini">
      <el-form-item label="到期状态">
        <el-select v-model="off_time_state" placeholder="请选择" @change="search">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addSubjectPermission" icon="el-icon-plus">添加科目权限</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="editAllTime">批量修改截止时间</el-button>
      </el-form-item>

      <el-button style="float: right" size="mini" round type="info" @click="AddCourse">继续添加课程<i class="el-icon-d-arrow-right el-icon--right"></i></el-button>
    </el-form>
    <div class="table-style">
      <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column align="center" width="50" label="序号">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="educational_institution_name" label="客户名称"></el-table-column>
        <el-table-column align="center" prop="subject_name" label="科目名称"></el-table-column>
        <!-- <el-table-column align="center" prop="created_time" label="录入时间"></el-table-column> -->
        <el-table-column align="center" prop="off_time" label="截止日期"></el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-link style="padding-left: 10px; padding-right: 10px" @click="updateSubjectPermission(scope.row)" type="primary">编辑</el-link>

            <el-link style="padding-left: 10px; padding-right: 10px" @click="deleteSubjectPermission(scope.row)" type="primary">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange" :current-page="page_no" :page-size="page_size" :total="total" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
      <!-- <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="page_size"
        layout="total, prev, pager, next" :total="total"></el-pagination> -->
    </div>
    <el-dialog title="新增科目权限" :visible.sync="dialogVisible" width="600px">
      <el-form class="form-style" ref="form" :model="form" :rules="rules" label-width="100px" size="small" label-position="left">
        <el-form-item label="科目" required prop="subject_id">
          <el-select v-model="form.subject_id" placeholder="请选择科目" style="width: 400px" filterable :loading="loading">
            <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="截止日期" required prop="off_time">
          <!-- <el-date-picker style="width: 400px" v-model="form.off_time" type="date" placeholder="请选择系统截止日期" value-format="yyyy-MM-dd"></el-date-picker> -->
          <el-date-picker style="width: 400px" v-model="form.off_time" default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择系统截止日期" placement="bottom-start">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submit('form')">确 定</el-button>
        <el-button size="small" @click="quitDialog('form')">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改截止日期" :visible.sync="dialogVisible1" width="600px">
      <el-form class="form-style" ref="form1" :model="form1" :rules="rules" label-width="100px" size="small" label-position="left">
        <el-form-item label="截止日期" required prop="off_time">
          <!-- <el-date-picker style="width: 400px" v-model="form1.off_time" type="date" placeholder="请选择系统截止日期"
            value-format="yyyy-MM-dd"></el-date-picker> -->
          <el-date-picker style="width: 400px" v-model="form1.off_time" default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择系统截止日期" placement="bottom-start">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submit1('form1')">确 定</el-button>
        <el-button size="small" @click="quitDialog1('form1')">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSubjectPermissions,
  deleteSubjectPermissions,
  addSubjectPermissions,
  updateSubjectPermissions,
  // getEducationalInstitutionList,
  // getPrincipalUserList,
  getSubjectList,
  bulkUpdateSchoolSubjectAuthOfftime,
} from '@/api/admin'

export default {
  name: 'school-subject-permissions',
  data() {
    return {
      off_time_state: '2',
      options: [
        {
          id: '',
          name: '全部',
        },
        {
          id: '1',
          name: '已到期',
        },
        {
          id: '2',
          name: '未到期',
        },
      ],
      dialogVisible1: false,
      form1: {
        off_time: '',
      },
      multipleSelection: [],
      subjectPermissionId: '',
      loading: false,
      educational_institution_list: [],
      ruleForm: {
        educational_institution_id: '',
        user_id: '',
      },
      page_no: 1,
      page_size: 100,
      total: 0,
      tableData: [],
      principalUserList: [],
      subjectList: [],
      dialogVisible: false,
      form: {
        educational_institution_id: '',
        subject_id: '',
        off_time: '',
      },
      rules: {
        educational_institution_id: [
          {
            required: true,
            message: '请选择学校',
            trigger: 'change',
          },
          {
            required: true,
            message: '请选择学校',
            trigger: 'blur',
          },
        ],
        subject_id: [
          {
            required: true,
            message: '请选择科目',
            trigger: 'change',
          },
          {
            required: true,
            message: '请选择科目',
            trigger: 'blur',
          },
        ],
        off_time: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {},
  mounted() {
    if (!this.$route.query.id) {
      this.$message.warning('请选择校区')
      this.$router.push({
        name: 'cooperative-school',
      })
      return
    }

    this.getSubjectPermissions()
    // this.getPrincipalUserList();
    // this.getEducationalInstitutionList();
  },
  methods: {
    editAllTime() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择科目')
      } else {
        this.form1.off_time = this.$route.query.off_time
        this.dialogVisible1 = true
      }
    },
    quitDialog1(formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible1 = false
    },
    submit1(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          bulkUpdateSchoolSubjectAuthOfftime({
            schoolSubjectIds: JSON.stringify(this.multipleSelection),
            ...this.form1,
          }).then((res) => {
            console.log(res)
            this.$message.success('修改权限成功！')
            this.dialogVisible1 = false
            this.getSubjectPermissions()
          })
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = []
      val.map((item) => {
        this.multipleSelection.push(item.id)
      })
      console.log(this.multipleSelection)
    },

    getSubjectList() {
      getSubjectList({ subject_state: 1, page_size: 200 }, true).then((res) => {
        this.subjectList = res.subject_list
      })
    },
    // // 获取校长账号列表
    // getPrincipalUserList() {
    //   this.loading = true;
    //   getPrincipalUserList({
    //     page_size: 200,
    //   }).then((res) => {
    //     this.principalUserList = res.principal_user_list;
    //     this.loading = false;
    //   });
    // },
    // // 获取合作学校列表
    // getEducationalInstitutionList(query) {
    //   this.loading = true;
    //   getEducationalInstitutionList({
    //     educational_institution_name: query,
    //     page_size: 200,
    //   }).then((res) => {
    //     this.educational_institution_list = res.educational_institution_list;
    //     this.loading = false;
    //   });
    // },
    addSubjectPermission() {
      if (!this.$route.query.id) {
        this.$message.warning('请选择校区')
        return
      }

      this.dialogVisible = true
      this.subjectPermissionId = ''
      this.form.subject_id = ''
      this.form.off_time = this.$route.query.off_time
      this.getSubjectList()
    },
    quitDialog(formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
    },
    updateSubjectPermission(row) {
      this.subjectPermissionId = row.id
      this.form.educational_institution_id = row.educational_institution_id
      this.form.subject_id = row.subject_id
      this.form.off_time = row.off_time
      this.getSubjectList()
      this.dialogVisible = true
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.subjectPermissionId) {
            updateSubjectPermissions({
              subject_promssion_educational_institution_id: this
                .subjectPermissionId,
              educational_institution_id: this.$route.query.id,
              subject_id: this.form.subject_id,
              off_time: this.form.off_time,
            }).then(() => {
              this.$message.success('修改权限成功！')
              this.dialogVisible = false
              this.getSubjectPermissions()
            })
          } else {
            addSubjectPermissions({
              educational_institution_id: this.$route.query.id,
              subject_id: this.form.subject_id,
              off_time: this.form.off_time,
            }).then(() => {
              this.$message.success('上传权限成功！')
              this.dialogVisible = false
              this.getSubjectPermissions()
            })
          }
        }
      })
    },
    deleteSubjectPermission(row) {
      this.$confirm('确定删除当前科目权限?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteSubjectPermissions({
          subject_promssion_educational_institution_id: row.id,
        }).then(() => {
          this.$message.success('删除成功！')
          this.getSubjectPermissions()
        })
      })
    },
    search() {
      this.page_no = 1
      this.getSubjectPermissions()
    },
    handleSizeChange2(val) {
      this.page_size = val
      this.getSubjectPermissions()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getSubjectPermissions()
    },

    getSubjectPermissions() {
      if (!this.$route.query.id) {
        this.$message.warning('请选择校区')
        return
      }

      getSubjectPermissions({
        educational_institution_id: this.$route.query.id,
        user_id: '',
        page_no: this.page_no,
        off_time_state: this.off_time_state,
        page_size: this.page_size,
      }).then((res) => {
        this.tableData = res.subject_promission_list
        this.total = res.total
      })
    },

    AddCourse() {
      console.log('继续课程授权')
      this.$router.push({
        name: 'school-system-permissions',
        query: {
          id: this.$route.query.id,
          off_time: this.$route.query.off_time,
          name: this.$route.query.name,
          domain: this.$route.query.domain,
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
.school-subject-permissions {
  height: 100%;
  background-color: #fff;
  padding-top: 3px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  margin: 10px;
  border-radius: 5px;

  .table-style {
  }
}
</style>
